import { TemplateStringInputProps as Props } from "./TemplateStringInput";

export { default as TemplateStringInput } from "./TemplateStringInput";
export type TemplateStringInputProps = Props;
